import { object, string } from "yup";

export interface MailTemplateVariable {
  key: string;
  label: string;
}

export interface MailTemplateMeta {
  static_id: string;
  title: string;
  description: string;
  variables: MailTemplateVariable[];
}

export interface MailTemplate {
  subject: string | null;
  html: string | null;
}

export const mailTemplateSchema = object({
  subject: string().required(" "),
  html: string().required(" "),
});

export const MAIL_TEMPLATE_INITIAL_VALUES = {
  subject: "",
  html: "",
};
